import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: {},
  getUserSuccess: false,
  getUserError: null,
  getUserLoading: false,

  //check user
  checkUserLoading: false,
  checkUserSuccess: false,
  checkUserError: null,

  identity: {},
  getIdentitySuccess: false,
  getIdentityError: null,
  getIdentityLoading: false,

  editUserLoading: false,
  editUserSuccess: false,
  editUserError: null,

  editIdentityLoading: false,
  editIdentitySuccess: false,
  editIdentityError: null,

  createIdentityLoading: false,
  createIdentitySuccess: false,
  createIdentityError: null,

  walletInfo: {},
  getWalletInfoSuccess: false,
  getWalletInfoError: null,
  getWalletInfoLoading: false,

  withdrawLoading: false,
  withdrawSuccess: false,
  withdrawError: null,

  transactions: [],
  getTransactionsSuccess: false,
  getTransactionsError: null,
  getTransactionsLoading: false,

  liveChallenges: [],
  getLiveChallengesSuccess: false,
  getLiveChallengesError: null,
  getLiveChallengesLoading: false,

  //submit transaction
  submitTransactionLoading: false,
  submitTransactionSuccess: false,
  submitTransactionError: null,
};

const ProfileSlice = createSlice({
  name: "Profile",
  initialState,
  reducers: {
    getUserRequest: (state) => {
      state.getUserLoading = true;
      state.getUserError = null;
      state.getUserSuccess = false;
    },
    getUserSuccess: (state, { payload }) => {
      state.user = payload;
      state.getUserLoading = false;
      state.getUserError = null;
      state.getUserSuccess = true;
    },
    getUserError: (state, { payload }) => {
      state.getUserLoading = false;
      state.getUserError = payload;
      state.getUserSuccess = false;
      state.user = {};
    },

    getIdentityRequest: (state) => {
      state.getIdentityLoading = true;
      state.getIdentityError = null;
      state.getIdentitySuccess = false;
      state.identity = {};
    },
    getIdentitySuccess: (state, { payload }) => {
      state.identity = payload;
      state.getIdentityLoading = false;
      state.getIdentityError = null;
      state.getIdentitySuccess = true;
    },
    getIdentityError: (state, { payload }) => {
      state.getIdentityLoading = false;
      state.getIdentityError = payload;
      state.getIdentitySuccess = false;
      state.identity = {};
    },

    editUserRequest: (state) => {
      state.editUserLoading = true;
      state.editUserError = null;
      state.editUserSuccess = false;
    },
    editUserSuccess: (state) => {
      state.editUserLoading = false;
      state.editUserError = null;
      state.editUserSuccess = true;
    },
    editUserError: (state, { payload }) => {
      state.editUserLoading = false;
      state.editUserError = payload;
      state.editUserSuccess = false;
    },

    editIdentityLoading: (state) => {
      state.editIdentityLoading = true;
      state.editIdentityError = null;
      state.editIdentitySuccess = false;
    },
    editIdentitySuccess: (state) => {
      state.editIdentityLoading = false;
      state.editIdentityError = null;
      state.editIdentitySuccess = true;
    },
    editIdentityError: (state, { payload }) => {
      state.editIdentityLoading = false;
      state.editIdentityError = payload;
      state.editIdentitySuccess = false;
    },

    createIdentityRequest: (state) => {
      state.createIdentityLoading = true;
      state.createIdentityError = null;
      state.createIdentitySuccess = false;
    },
    createIdentitySuccess: (state) => {
      state.createIdentityLoading = false;
      state.createIdentityError = null;
      state.createIdentitySuccess = true;
    },
    createIdentityError: (state, { payload }) => {
      state.createIdentityLoading = false;
      state.createIdentityError = payload;
      state.createIdentitySuccess = false;
    },

    getWalletInfoRequest: (state) => {
      state.getWalletInfoLoading = true;
      state.getWalletInfoError = null;
      state.getWalletInfoSuccess = false;
      state.walletInfo = {};
    },
    getWalletInfoSuccess: (state, { payload }) => {
      state.walletInfo = payload;
      state.getWalletInfoLoading = false;
      state.getWalletInfoError = null;
      state.getWalletInfoSuccess = true;
    },
    getWalletInfoError: (state, { payload }) => {
      state.getWalletInfoLoading = false;
      state.getWalletInfoError = payload;
      state.getWalletInfoSuccess = false;
      state.walletInfo = {};
    },

    getTransactionsRequest: (state) => {
      state.getTransactionsLoading = true;
      state.getTransactionsError = null;
      state.getTransactionsSuccess = false;
      state.transactions = [];
    },
    getTransactionsSuccess: (state, { payload }) => {
      state.transactions = payload;
      state.getTransactionsLoading = false;
      state.getTransactionsError = null;
      state.getTransactionsSuccess = true;
    },
    getTransactionsError: (state, { payload }) => {
      state.getTransactionsLoading = false;
      state.getTransactionsError = payload;
      state.getTransactionsSuccess = false;
      state.transactions = [];
    },

    getLiveChallengesRequest: (state) => {
      state.getLiveChallengesLoading = true;
      state.getLiveChallengesError = null;
      state.getLiveChallengesSuccess = false;
      state.liveChallenges = [];
    },
    getLiveChallengesSuccess: (state, { payload }) => {
      state.liveChallenges = payload;
      state.getLiveChallengesLoading = false;
      state.getLiveChallengesError = null;
      state.getLiveChallengesSuccess = true;
    },
    getLiveChallengesError: (state, { payload }) => {
      state.getLiveChallengesLoading = false;
      state.getLiveChallengesError = payload;
      state.getLiveChallengesSuccess = false;
      state.liveChallenges = [];
    },

    withdrawRequest: (state) => {
      state.withdrawLoading = true;
      state.withdrawError = null;
      state.withdrawSuccess = false;
    },
    withdrawSuccess: (state) => {
      state.withdrawLoading = false;
      state.withdrawError = null;
      state.withdrawSuccess = true;
    },
    withdrawError: (state, { payload }) => {
      state.withdrawLoading = false;
      state.withdrawError = payload;
      state.withdrawSuccess = false;
    },

    submitTransactionRequest: (state) => {
      state.submitTransactionLoading = true;
      state.submitTransactionError = null;
      state.submitTransactionSuccess = false;
    },
    submitTransactionSuccess: (state) => {
      state.submitTransactionLoading = false;
      state.submitTransactionError = null;
      state.submitTransactionSuccess = true;
    },
    submitTransactionError: (state, { payload }) => {
      state.submitTransactionLoading = false;
      state.submitTransactionError = payload;
      state.submitTransactionSuccess = false;
    },
    //check user
    checkUserRequest: (state) => {
      state.checkUserLoading = true;
      state.checkUserSuccess = false;
      state.checkUserError = null;
    },
    checkUserSuccess: (state, action) => {
      state.checkUserLoading = false;
      state.checkUserSuccess = true;
      state.checkUserError = null;
    },
    checkUserErrors: (state, action) => {
      state.checkUserLoading = false;
      state.checkUserSuccess = false;
      state.checkUserError = action.payload;
    },
    clearStates: (state) => {
      state.editUserError = null;
      state.editUserSuccess = false;

      state.editIdentityError = null;
      state.editIdentitySuccess = false;

      state.getWalletInfoError = null;
      state.getWalletInfoSuccess = false;

      state.getTransactionsError = null;
      state.getTransactionsSuccess = false;

      state.getLiveChallengesError = null;
      state.getLiveChallengesSuccess = false;

      state.getUserError = null;
      state.getUserSuccess = false;

      state.getIdentityError = null;
      state.getIdentitySuccess = false;

      state.withdrawError = null;
      state.withdrawSuccess = false;

      state.submitTransactionError = null;
      state.submitTransactionSuccess = false;

      state.checkUserError = false;
      state.checkUserSuccess = false;
    },
  },
});
export const ProfileActions = ProfileSlice.actions;

export default ProfileSlice.reducer;
